<template>
  <div class="progress-icon">
    <div class="editor-modal"></div>
    <div>
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
    </div>
    <div class="text-style">
      <br/>场景加载中...
    </div>
  </div>
</template>

<script>
export default {
  name: 'Caterpillars'
}
</script>

<style lang='less'>
.progress-icon {
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 60px;
  position: absolute;
  z-index: 2009;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .text-style{
    margin-left: -70px;
    margin-top: 20px;
    color: #fff;
  }
}

// 毛毛虫loading
.progress-icon {
  .line {
    position: relative;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: #FFF;
  }
  .line:nth-last-child(1) {
    left: 5px;
    animation: progresskeyfr 0.6s 0.1s linear infinite;
  }
  .line:nth-last-child(2) {
    animation: progresskeyfr 0.6s 0.2s linear infinite;
  }
  .line:nth-last-child(3) {
    left: -5px;
    animation: progresskeyfr 0.6s 0.3s linear infinite;
  }
  .line:nth-last-child(4) {
    left: -10px;
    animation: progresskeyfr 0.6s 0.4s linear infinite;
  }
  .line:nth-last-child(5) {
    left: -15px;
    animation: progresskeyfr 0.6s 0.5s linear infinite;
  }
  @keyframes progresskeyfr {
    0%,
    100% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(0, 15px);
    }
  }
}
</style>
